/**
 * `expand-01` glyph (Untitled UI). Two arrows pointing to the
 * top-right and bottom-left corners to convey a maximize / expand
 * action. Uses `currentColor` so the enclosing button controls
 * tinting.
 *
 * Geometry mirrors the Figma maximize affordance on the chart
 * preview hover overlay (node `16844:35805`).
 */
export type MaximizeGlyphProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function MaximizeGlyph({ size = 24, className }: MaximizeGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M21 9V3H15M14 10L21 3M3 15V21H9M10 14L3 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MaximizeGlyph;
